// extracted by css-extract-rspack-plugin
export default {"row":"iSQDJ","nowrap":"B0Voy","wrap":"TOPDN"};